/* eslint-disable react/no-unstable-nested-components */
import { useMemo } from "react";
import { ColumnDef, Table } from "@jhool-io/fe-components";
import ListState from "../../../../components/ListState/ListState";
import {
    IPrescriptionEvent,
    PrescriptionEventStatusDescriptions,
} from "../../types/e-prescribe.types";
import { formatDate } from "../../../../utils/helpers";
import { getPrecriptionStatusForDisplay } from "../../helpers/e-prescribe.helpers";

interface PrescriptionEventsProps {
    events: IPrescriptionEvent[];
}

export default function PrescriptionEvents({
    events,
}: PrescriptionEventsProps) {
    const columns: ColumnDef<IPrescriptionEvent>[] = useMemo(() => {
        return [
            {
                accessorKey: "event_type",
                header: "Event Type",
                cell: ({ row }) => (
                    <span className="capitalize">
                        {row.original.event_type ?? "--"}
                    </span>
                ),
            },
            {
                accessorKey: "event_code",
                header: "Event Code",
                cell: ({ row }) => row.original.event_code ?? "--",
            },
            {
                accessorKey: "prescription_event_id",
                header: "Description",
                cell: ({ row }) => {
                    if (!row.original.event_code) return "--";
                    if (
                        row.original.event_code === "PENDING" ||
                        row.original.event_code === "SENT"
                    ) {
                        return "--";
                    }
                    return (
                        <div className="max-w-[300px] text-wrap">
                            {PrescriptionEventStatusDescriptions[
                                row.original.event_code
                            ] ?? "--"}
                        </div>
                    );
                },
            },
            {
                accessorKey: "event_date",
                header: "Event Date",
                cell: ({ row }) =>
                    row.original.event_date
                        ? formatDate(row.original.event_date)
                        : "--",
            },
            {
                accessorKey: "prescription_status",
                header: "Prescription Status",
                cell: ({ row }) => {
                    if (!row.original.prescription_status) return "--";
                    return (
                        <span>
                            {getPrecriptionStatusForDisplay(
                                row.original.prescription_status
                            )}
                        </span>
                    );
                },
            },
        ];
    }, []);

    return (
        <div>
            <h2 className="text-title mb-[--spacing-items] font-semibold">
                Prescription Events
            </h2>
            {events.length === 0 && (
                <ListState
                    isError={false}
                    stateHelperText="Prescriptions events will appear here when available"
                    emptyMessage="No prescriptions events to display"
                />
            )}
            {events.length > 0 && <Table columns={columns} data={events} />}
        </div>
    );
}
